/*
 *  Accordion
 *    Styles for controlling accordions.
 *    Will init on all [data-accordion]'s by default, but can be supered as well
 *
 *  Version:
 *    1.0.0 - 2018/12/03
 */
import $ from 'jquery';
import * as ResponsiveSizes from './../../settings/Responsive';

export const SLIDE_SELECTOR = '[data-accordion-slide]';
export const TITLE_SELECTOR = '[data-accordion-title]';
export const BODY_SELECTOR = '[data-accordion-body]';

export const EXPANDED_CLASS = 'is-expanded';

export class Accordion {
  constructor(container) {
    this.container = container;

    //Settings
    this.allowMultiple = container.attr('data-multiple') == "true" ? true : false;
    this.allowMobileMultiple = container.attr('data-mobile-multiple') == "true" ? true : false;

    //Setup data attributes
    this.slides = container.find(SLIDE_SELECTOR);
    this.slides.each((e, i) => {
      let self = $(i);
      if(self.attr('data-index')) return;
      //Setup indexes.
      self.attr('data-index', e);
      self.find(`${TITLE_SELECTOR},${BODY_SELECTOR}`).attr('data-index', e);
    });

    //Event listeners
    container.on('click touch', TITLE_SELECTOR, e => this.onTitleClick(e));
  }

  getCurrentIndex() {
    let indexes = [];
    this.slides.each((i,e) => {
      let s = $(e);
      if(!s.hasClass(EXPANDED_CLASS)) return;
      indexes.push(s.attr('data-index'));
    });
    if ($(window).width() < ResponsiveSizes.medium) {
      return this.allowMobileMultiple ? indexes : indexes[0] || null;  
    } else {
      return this.allowMultiple ? indexes : indexes[0] || null;
    }
  }

  getSlide(index) {
    //Find slide by index
    return this.container.find(`${SLIDE_SELECTOR}[data-index="${index}"]`);
  }

  useSlide(index) {
    if(index == this.getCurrentIndex()) return;

    //Get slide
    let slide = this.getSlide(index);
    let slideBody = slide.find(BODY_SELECTOR);
    let slideBodies = this.slides.find(BODY_SELECTOR);

    //If Multiple just toggle
    if ($(window).width() < ResponsiveSizes.medium) {
      if(this.allowMobileMultiple) return slide.toggleClass(EXPANDED_CLASS);
    } else {
      if(this.allowMultiple) return slide.toggleClass(EXPANDED_CLASS);
    }
    
    //Not multple, is currently open?
    let close = slide.hasClass(EXPANDED_CLASS);
    this.slides.removeClass(EXPANDED_CLASS);//Close all
    //slideBodies.slideUp(200);
    if(close) return;//If was open, leave closed

    //Was not opened before, open now.
    slide.addClass(EXPANDED_CLASS);
    //slideBody.slideDown(200);
  }

  onTitleClick(e) {
    //Get Element
    let self = $(e.currentTarget);
    let index = parseInt(self.attr('data-index'));//Get Index
    if(isNaN(index)) return;//Has index?

    //Cancel click
    e.preventDefault();
    e.stopPropagation();

    // if opened close when double tap
    if(index == this.getCurrentIndex()){
      self.closest(SLIDE_SELECTOR).removeClass(EXPANDED_CLASS);
      return
    };
    //Set Slide
    this.useSlide(index);
  }
}
